import React, { useEffect, useContext, useState } from "react";
import { DataContext } from '../../data/DataContext';
import { IconFaceHappy, IconFaceSad } from '../../svg/index';

const Step5 = () => {
    const { SOA, setSOA, changeHandler } = useContext(DataContext);

    const finish = () => { window.location.reload(); };


    return (
        <div className="step">
            <div className="step-container-soa">
                <div className="mt-15">

                    <span className="title2">
                        {SOA.guardado && "¡Solicitud exitosa!"}
                        {!SOA.guardado && "¡Ooops! Ocurrió un error al generar la solicitud "}
                    </span>
                </div>
                <div className="mt-15 mb-30">
                    <span className="title3">
                        {SOA.guardado && "Muchas gracias por confiar en Seguros LAFISE, la aseguradora digital regional."}
                        {!SOA.guardado && "Pero no te preocupes, hemos recibido tus datos."}
                    </span>
                </div>
                <div className="container-finish">
                    {SOA.guardado && <div className="title4 txt-center">Tú número de solicitud es: <span className="color-main negrita"> {SOA.numeroSolicitud} </span> </div>}
                    <div className="container-face-finish">
                        {SOA.guardado && <IconFaceHappy classNameIcon="icon-face"></IconFaceHappy>}
                        {!SOA.guardado && <IconFaceSad classNameIcon="icon-face"></IconFaceSad>}
                    </div>
                    {
                        SOA.guardado && SOA.esTelepago == false && <div className="title4 mb-15 ml-20 mr-20">
                            <p>En breve recibirás en tu correo electrónico el recibo de compra.</p>
                            <p>Nuestros ejecutivos se contactarán contigo para confirmar datos y coordinar la entrega de tu carnet de seguro.</p>
                        </div>
                    }
                    {
                        SOA.guardado && SOA.esTelepago == true && <div className="title4 mb-15 ml-20 mr-20">
                            <p>Para culminar el proceso, recibirás la llamada de nuestros ejecutivos para procesar el pago y coordinar la entrega de tu carnet de seguro.</p>
                            <p>Recordá tener a mano la tarjeta con la tarjeta de débito o crédito que realizarás la compra.</p>
                        </div>
                    }
                    {
                        !SOA.guardado && <div className="title4  mb-15">
                            <p>En breve un ejecutivo se contactará contigo para confirmar datos y cerrar la venta de tu Seguro Obligatorio de Automóvil.</p>
                            <p>Recordá tener a mano la tarjeta de crédito o débito con la que realizarás la compra.</p>
                        </div>
                    }
                    <div className="control-button-finish pt-30 pb-30">
                        <button type="button" className="control-button-btn-finish" onClick={finish}>Finalizar</button>
                    </div>
                </div>
            </div>
        </div>
    );

};

export default Step5;